import { Capacitor, registerPlugin } from '@capacitor/core';
import type { PluginListenerHandle } from '@capacitor/core';

// Bridge to the in-app native plugin (ios/App/App/RidazCallsPlugin.swift and
// android/.../RidazCallsPlugin.java) that rings 1:1 calls through CallKit (iOS) / a
// full-screen call notification (Android) even when the app is closed.
export interface NativeCallAccept {
  callId: string;
  threadId: string;
  type: 'audio' | 'video';
}

interface RidazCallsPlugin {
  register(): Promise<{ platform: string }>;
  endCall(options: { callId: string }): Promise<void>;
  consumePendingAccept(): Promise<{ accept?: NativeCallAccept }>;
  addListener(event: 'voipToken', cb: (info: { token: string; env: 'sandbox' | 'production' }) => void): Promise<PluginListenerHandle>;
  addListener(event: 'callAccepted', cb: (info: NativeCallAccept) => void): Promise<PluginListenerHandle>;
  addListener(event: 'callEnded', cb: (info: { callId: string; threadId: string; answered: boolean }) => void): Promise<PluginListenerHandle>;
}

export const RidazCalls = registerPlugin<RidazCallsPlugin>('RidazCalls');

export const hasNativeCalls = (): boolean => Capacitor.isNativePlatform();

// Tells the OS the call is over (removes CallKit's call / the ring notification).
export const endNativeCall = (callId: string | undefined | null): void => {
  if (!callId || !hasNativeCalls()) return;
  RidazCalls.endCall({ callId }).catch(() => undefined);
};
